interface UserMessageProps {
  submittedMessage?: string;
  listTitle?: string;
  listItems?: string[];
  variant?: 'text' | 'list';
}

export default function UserMessage({ submittedMessage, listTitle, listItems, variant = 'text' }: UserMessageProps) {
  if (variant === 'list' && listTitle && listItems) {
    return (
      <>
        <style jsx>{`
          .user-message ul {
            list-style: none;
            padding-left: 0;
          }
          .user-message li {
            position: relative;
            padding-left: 1.5rem;
            margin-bottom: 0.25rem;
            line-height: 1.3;
          }
          .user-message li::before {
            content: '•';
            position: absolute;
            left: 0.5rem;
            color: #000;
          }
        `}</style>
        <div className='user-message body-sm bg-blue-100 rounded-tl-3xl rounded-tr-3xl rounded-bl-3xl pl-6 pr-8 py-2 min-w-[20%] max-w-[85%] md:max-w-[50%] lg:mb-5 self-end mr-2 lg:mr-0'>
          <div className='mb-0'>{listTitle}</div>
          <ul>
            {listItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </>
    );
  }

  if (!submittedMessage) return null;

  return (
    <div className='user-message-reg body-sm bg-blue-100 rounded-tl-3xl rounded-tr-3xl rounded-bl-3xl pl-6 pr-8 py-2 min-w-[20%] max-w-[85%] md:max-w-[50%] lg:mb-5 self-end mr-2 lg:mr-0'>
      <div id='input-text'>{submittedMessage}</div>
    </div>
  );
}
